/* © Facilogi. See LICENSE file for full copyright & licensing details. */

import { $t } from "App/IOC";
import { Column, CustomError } from "App/Models";
// import { Dictionary } from "App/Contracts";
import Columns from "App/UseCases/Columns";
// import Fields from "Shared/UseCases/Choices/Fields";

let sort: Column;
let columns: Column[] = [];

function GetDefaultSort(): Column {
    /* To avoid an issue with $t being empty because it has yet to be injected to Ioc because if
       we put this instantiation at the module level here, it will get executed during
       node module importation step, which is before we inject the actual $t() implementation into
       our Ioc (Through Web/Main.ts), so we wrap it in a funtion. */
    if( sort === undefined )
        sort = new Column( "Sequence", $t( "PRODUCTS_columnSequence" ) );

    return sort;
}

function getDefault(): Column[] {
    if( columns.length === 0 )
        columns = [
            GetDefaultSort(),
            new Column( "Name", $t( "PRODUCTS_columnName" ) ),
            new Column( "Description", $t( "PRODUCTS_columnDescription" ) ),
            new Column( "Active", $t( "PRODUCTS_columnState" ), "Status" ),
            new Column( "CreatedAt", $t( "PRODUCTS_columnCreatedAt" ), "date" )
        ];

    return columns;
}

async function Get(): Promise<[ Column[], CustomError | undefined ]> {
    return await Columns.Get( "Products", getDefault() );
}

// function GetMapping(): Dictionary<string> {
//     return { ...Fields.GetMapping() };
// }

async function Toggle( existingColumn: Column ): Promise<CustomError | undefined> {
    return await Columns.Toggle( "Products", existingColumn, getDefault() );
}

export default {
    GetDefaultSort,
    Get,
    // GetMapping,
    Toggle
};
